import type { EnrollmentResponseCourseInstructorBasicInfo } from './enrollmentResponseCourseInstructorBasicInfo';
import type { EnrollmentResponseCourseInstructorSocial } from './enrollmentResponseCourseInstructorSocial';

/**
 * 강사 정보
 */
export type EnrollmentResponseCourseInstructor = {
  /** 사용자 기본 정보 */
  basicInfo: EnrollmentResponseCourseInstructorBasicInfo;
  /** 소셜 관계 정보 */
  social?: EnrollmentResponseCourseInstructorSocial;
};
